import { OrderedMap, OrderedSet, fromJS } from 'immutable';
import { AnyAction } from 'redux';

import { TypedMap } from 'utils/typed-map';
import Volunteer from 'entities/volunteers/model';

import {
  ADD,
  ADD_MULTIPLE,
  SET_TOTAL_VOLUNTEERS,
  SET_DISPLAYED_VOLUNTEER_IDS,
  UPDATE_VOLUNTEER_STATUS,
  UPDATE_VOLUNTEER_PROPERTY,
} from './constants';

export type VolunteerState = TypedMap<{
  volunteers: OrderedMap<string, Volunteer>;
  total: number;
  displayedVolunteerIds: OrderedSet<string>;
}>;

const initialState: VolunteerState = fromJS({
  volunteers: OrderedMap(),
  total: 0,
  displayedVolunteerIds: OrderedSet(),
});

export default (state = initialState, action: AnyAction): VolunteerState => {
  switch (action.type) {
    case ADD:
      return state.set(
        'volunteers',
        state.get('volunteers').set(action.volunteer.id, action.volunteer)
      );

    case SET_DISPLAYED_VOLUNTEER_IDS:
      return state.set('displayedVolunteerIds', action.volunteerIds);

    case ADD_MULTIPLE:
      return state.set('volunteers', state.get('volunteers').merge(action.volunteers));

    case SET_TOTAL_VOLUNTEERS:
      return state.set('total', action.total);

    case UPDATE_VOLUNTEER_STATUS:
      return state.setIn(['volunteers', action.id, 'status'], action.status);

    case UPDATE_VOLUNTEER_PROPERTY:
      return state.setIn(['volunteers', action.id, action.property], action.value);

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
